import {
  apiAxios
} from "@/api/axios";
import base from '../config'
let baseURL = base.baseURL
let token = localStorage.getItem('japan_access_token')
// let baseURL = 'https://jpapi.rakumart.cn'
export default {
  //可筛选银行
  bankOption: (data) => apiAxios('post', baseURL + '/financial.bankOption', data),
  //待确认-列表
  unConfirmList: (data) => apiAxios('post', baseURL + '/financial.unConfirmList', data),
  //财务确认
  confirm: (data) => apiAxios('post', baseURL + '/financial.confirm', data),
  //待确认-修改
  updatePayInfo: (data) => apiAxios('post', baseURL + '/financial.updatePayInfo', data),
  //待确认-回退
  backToUnPaid: (data) => apiAxios('post', baseURL + '/financial.backToUnPaid', data),
  //银行账单--待确认入金匹配可能的银行账单选项
  matchPossibleBankBill: (data) => apiAxios('post', baseURL + '/bill.bank.matchPossibleBankBill', data),
  //待确认列表-设置业务备注
  updateYRemark: (data) => apiAxios('post', baseURL + '/bill.updateYRemark', data),
  //合并支付待确认汇款详情
  mergePayDetail: (data) => apiAxios('post', baseURL + '/bill.mergePayDetail', data),

  //人工登记汇款-新增
  financialStore: (data) => apiAxios('post', baseURL + '/financial.noOwner.financialStore', data),
  //人工登记汇款-列表
  financialStoreList: (data) => apiAxios('post', baseURL + '/financial.noOwner.financialStoreList', data),
  //人工登记汇款-确认
  financialStoreConfirm: (data) => apiAxios('post', baseURL + '/financial.noOwner.financialStoreConfirm', data),

  //客户收支明细-列表
  userBill: (data) => apiAxios('post', baseURL + '/financial.userBill', data),

  //交易号付款-列表
  purchaseList: (data) => apiAxios('post', baseURL + '/financial.purchaseList', data),
  //交易号付款-付款
  purchaseListPay: (data) => apiAxios('post', baseURL + '/financial.purchaseListPay', data),

  //提现-列表
  cashList: (data) => apiAxios('post', baseURL + '/cash.list', data),
  //提现-可选的支付方式
  cashBanks: (data) => apiAxios('post', baseURL + '/cash.banks', data),
  //提现-后台发起提现申请
  balanceExtract: (data) => apiAxios('post', baseURL + '/cash.balanceExtract', data),
  //提现-后台业务确认手续费
  cashyEdit: (data) => apiAxios('post', baseURL + '/cash.yEdit', data),
  //提现-后台业务审核
  cashyConfirm: (data) => apiAxios('post', baseURL + '/cash.yConfirm', data),
  //提现-汇款
  cashConfirm: (data) => apiAxios('post', baseURL + '/cash.confirm', data),
  //提现-拒绝
  cashRefuse: (data) => apiAxios('post', baseURL + '/cash.refuse', data),
  // 待确认列表
  billunConfirmList: (data) => apiAxios('post', baseURL + '/bill.unConfirmList', data),
  // 待确认列表-确认订单
  billBackToUnPaid: (data) => apiAxios('post', baseURL + '/bill.backToUnPaid', data),
  // 待确认列表-确认
  billConfirm: (data) => apiAxios('post', baseURL + '/bill.confirm', data),
  // 待确认列表-修改
  billUpdatePayInfo: (data) => apiAxios('post', baseURL + '/bill.updatePayInfo', data),
  // 支付方式列表
  billBillMethod: (data) => apiAxios('post', baseURL + '/bill.billMethod', data),
  // 已确认汇款列表
  confirmedList: (data) => apiAxios('post', baseURL + '/bill.confirmedList', data),
  // 交易号付款
  billPurchaseWaitPayList: (data) => apiAxios('post', baseURL + '/bill.purchaseWaitPayList', data),
  // 交易号付款-付款
  billPurchaseWaitPayConfirm: (data) => apiAxios('post', baseURL + '/bill.purchaseWaitPayConfirm', data),
  // 人工登记汇款-列表
  billNoOwnerFinancialStoreList: (data) => apiAxios('post', baseURL + '/bill.noOwner.financialStoreList', data),
  // 人工登记汇款-确认
  billNoOwnerFinancialStoreConfirm: (data) => apiAxios('post', baseURL + '/bill.noOwner.financialStoreConfirm', data),
  // 人工登记汇款-新增
  billNoOwnerFinancialStore: (data) => apiAxios('post', baseURL + '/bill.noOwner.financialStore', data),
  // 人工登记汇款-取消
  financialCancel: (data) => apiAxios('post', baseURL + '/bill.noOwner.financialCancel', data),
  // 银行账单--列表
  bankList: (data) => apiAxios('post', baseURL + '/bill.bank.list', data),
  //银行账单--重新匹配
  bankReMatch: (data) => apiAxios('post', baseURL + '/bill.bank.reMatch', data),
  //银行账单--选定银行账单进行自动修改匹配
  updateBillAndMatch: (data) => apiAxios('post', baseURL + '/bill.bank.updateBillAndMatch', data),
  //银行账单--批量修改处理备注
  updateDealRemark: (data) => apiAxios('post', baseURL + '/bill.bank.updateDealRemark', data),


  //客户-详情-获取客户入金名义列表
  clientPayAccountList: (data) => apiAxios('post', baseURL + '/client.clientPayAccountList', data),
  //客户-详情-设置客户入金名义
  setClientPayAccount: (data) => apiAxios('post', baseURL + '/client.setClientPayAccount', data),


  // 财务客户预留款
  reservePayment: (data) => {
    data.token = token
    return apiAxios('post', baseURL + '/accounting.reservePayment', data)
  },
  // 财务客户预留款
  payOffOrdno: (data) => {
    data.token = token
    return apiAxios('post', baseURL + '/accounting.payOffOrdno', data)
  },
  // 财务客户预留款
  alibabaPayOffOrdno: (data) => {
    data.token = token
    return apiAxios('post', baseURL + '/accounting.alibabaPayOffOrdno', data)
  },
  // 财务客户预留款
  alibabaRefund: (data) => {
    data.token = token
    return apiAxios('post', baseURL + '/accounting.alibabaRefund', data)
  },
  //客户账单
  balanceChange: (data) => apiAxios('post', baseURL + '/bill.balanceChange', data),
  //银行账单--标记已人工审核
  signPersonConfirmed: (data) => apiAxios('post', baseURL + '/bill.bank.signPersonConfirmed', data),

  /* 结汇*/
  //结汇列表
  tradeOrderList: (data) => apiAxios('post', baseURL + '/worldFirst.tradeOrderList', data),
  //结汇列表TabNum
  tradeOrderListTabNum: (data) => apiAxios('post', baseURL + '/worldFirst.tradeOrderListTabNum', data),

  /*出入金调整申请*/
  //出入金调整申请-列表tab统计
  adjustApplicationListTab: (data) => apiAxios('post', baseURL + '/bill.adjustApplication.listTab', data),
  //出入金调整申请-列表
  adjustApplicationList: (data) => apiAxios('post', baseURL + '/bill.adjustApplication.list', data),
  //出入金调整申请-状态枚举
  adjustApplicationStatusOptions: (data) => apiAxios('post', baseURL + '/bill.adjustApplication.statusOptions', data),
  //出入金调整申请-申请类型枚举
  adjustApplicationTypeOptions: (data) => apiAxios('post', baseURL + '/bill.adjustApplication.typeOptions', data),
  //出入金调整申请-出入金调整申请
  adjustApplicationCreate: (data) => apiAxios('post', baseURL + '/bill.adjustApplication.create', data),
  //出入金调整申请-取消申请
  adjustApplicationCancel: (data) => apiAxios('post', baseURL + '/bill.adjustApplication.cancel', data),
  //出入金调整申请-拒绝
  adjustApplicationReject: (data) => apiAxios('post', baseURL + '/bill.adjustApplication.reject', data),
  //出入金调整申请-确认
  adjustApplicationConfirm: (data) => apiAxios('post', baseURL + '/bill.adjustApplication.confirm', data),

  //退款核对列表tab
  problemFinanceCheckListTab: (data) => apiAxios('post', baseURL + '/problemFinanceCheck.listTab', data),
  //退款核对列表
  problemFinanceCheckList: (data) => apiAxios('post', baseURL + '/problemFinanceCheck.listV2', data),
  //退款核对-审核
  problemFinanceCheckAudit: (data) => apiAxios('post', baseURL + '/problemFinanceCheck.audit', data),
  //退款核对-更新审核备注
  problemFinanceCheckUpdateAuditRemark: (data) => apiAxios('post', baseURL + '/problemFinanceCheck.updateAuditRemark', data),

  //补货订单-列表tab统计
  purchaseAddListTab: (data) => apiAxios('post', baseURL + '/purchaseAdd.listTab', data),
  //补货订单-列表
  purchaseAddList: (data) => apiAxios('post', baseURL + '/purchaseAdd.list', data),
  //补货订单-是否维修订单映射
  purchaseAddIsReparationMap: (data) => apiAxios('post', baseURL + '/purchaseAdd.isReparationMap', data),
  //补货订单-详情
  purchaseAddDetail: (data) => apiAxios('post', baseURL + '/purchaseAdd.detail', data),
  //补买-新增
  purchaseAddStore: (data) => apiAxios('post', baseURL + '/purchaseAdd.store', data),
  //补货订单-获取订单详情选项
  purchaseAddGetOrderDetailOptions: (data) => apiAxios('post', baseURL + '/purchaseAdd.getOrderDetailOptions', data),
  //补货订单-获取原交易号选项
  getOriginPurchaseNoOptions: (data) => apiAxios('post', baseURL + '/purchaseAdd.getOriginPurchaseNoOptions', data),
  //补货订单-更新
  purchaseAddUpdate: (data) => apiAxios('post', baseURL + '/purchaseAdd.update', data),
  //补货订单-更新备注
  purchaseAddUpdateRemark: (data) => apiAxios('post', baseURL + '/purchaseAdd.updateRemark', data),
  //补货订单-审核
  purchaseAddAudit: (data) => apiAxios('post', baseURL + '/purchaseAdd.audit', data),
  //补货订单-删除
  purchaseAddDelete: (data) => apiAxios('post', baseURL + '/purchaseAdd.delete', data),

  // 交易号平台支付比对列表
  purchasePayCheckList: (data) => apiAxios('post', baseURL + '/bill.purchasePayCheckList', data),
  // 交易号平台支付比对  财务提醒采购补充资料
  purchasePayCheckRemind: (data) => apiAxios('post', baseURL + '/bill.purchasePayCheckRemind', data),
  // 交易号平台支付比对-采购端列表
  purchasePayCheckPurchaseList: (data) => apiAxios('post', baseURL + '/bill.purchasePayCheckPurchaseList', data),
  // 交易号平台支付比对补充资料
  purchasePayCheckSupplement: (data) => apiAxios('post', baseURL + '/bill.purchasePayCheckSupplement', data),
  // 交易号平台支付比对标记已处理
  purchasePayCheckDeal: (data) => apiAxios('post', baseURL + '/bill.purchasePayCheckDeal', data),
  // 交易号平台支付比记撤销处理
  purchasePayCheckUndeal: (data) => apiAxios('post', baseURL + '/bill.purchasePayCheckUndeal', data),
  // 交易号平台支付比对标记已处理备注更新
  purchasePayCheckUpdateRemark: (data) => apiAxios('post', baseURL + '/bill.purchasePayCheckUpdateRemark', data),
  // 交易号平台支付比对标记已处理备注更新
  orderNewPay: (data) => apiAxios('post', baseURL + '/bill.orderNewPay', data),

  // 不在系统中的交易号-列表
  purchaseNoNotInSystemList: (data) => apiAxios('post', baseURL + '/bill.purchaseNoNotInSystemList', data),
  //不在系统中的交易号-标记已处理
  purchaseNoNotInSystemDeal: (data) => apiAxios('post', baseURL + '/bill.purchaseNoNotInSystemDeal', data),
  //不在系统中的交易号-更新备注
  purchaseNoNotInSystemUpdateRemark: (data) => apiAxios('post', baseURL + '/bill.purchaseNoNotInSystemUpdateRemark', data),

  // WordFirst异常核对-列表
  worldfirstCheckList: (data) => apiAxios('post', baseURL + '/worldfirstCheck.list', data),
  // WordFirst异常核对-统计
  worldfirstCheckStat: (data) => apiAxios('post', baseURL + '/worldfirstCheck.stat', data),
  // WordFirst异常核对-更新审核备注
  worldfirstCheckUpdateAuditRemark: (data) => apiAxios('post', baseURL + '/worldfirstCheck.updateReviewRemark', data),
  //WordFirst异常核对-批量复核
  worldfirstCheckReview: (data) => apiAxios('post', baseURL + '/worldfirstCheck.review', data),
  //WordFirst异常核对-批量终审
  worldfirstCheckFinalConfirm: (data) => apiAxios('post', baseURL + '/worldfirstCheck.finalConfirm', data),
  //WordFirst异常核对阈值-详情
  worldfirstCheckFinalConfirmDetail: (data) => apiAxios('post', baseURL + '/config.worldfirstCheck.thresholdDetail', data),
  //WordFirst异常核对阈值-保存
  worldfirstCheckThresholdSave: (data) => apiAxios('post', baseURL + '/config.worldfirstCheck.thresholdSave', data),
  //WordFirst账单上传导入
  worldfirstCheckImportBill: (data) => apiAxios('post', baseURL + '/bill.wf.parseBill', data),
  //WordFirst-手动添加订单号
  manualMatch: (data) => apiAxios('post', baseURL + '/worldfirstCheck.manualMatch', data),

  // 交易号平台支付比对标记已处理状态同步
  syncByPurchaseNo: (data) => apiAxios('post', baseURL + '/bill.syncByPurchaseNo', data),

  // 平台账单-列表
  feeList: (data) => apiAxios('post', baseURL + '/bill.fee.list', data),
  // 平台账单-费用导出
  feeExport: (data, config) => apiAxios('post', baseURL + '/bill.fee.export', data, config),
  // 账户中心-中国及日本平台账户余额
  accountBalanceList: (data) => apiAxios('post', baseURL + '/bill.accountBalance.list', data),
}
